/**
 * Initial state
 */
export const state = {
    permission: null,
}

/**
 * Mutations
 */
export const mutations = {

    SET_PERMISSION: (state, permission) => {
        state.permission = permission
    },
}

/**
 * Actions
 */
export const actions =
{
    savePermission({ commit }, payload) {
        commit('SET_PERMISSION', payload)
    },

    async fetchPermission({ commit, dispatch }) {
        try {
            const { data } = await axios.get(api.path('permission.index'))
            commit('SET_PERMISSION', data.data)
        } catch (e) {
            commit('FETCH_USER_FAILURE', payload)
        }
    },
}

/**
 * Getters
 */
export const getters = {
    permission: state => state.permission,
}
